const USER_PROFILE_KEY = 'userProfile';

export function setUserProfile(profile) {
  if (!profile) return;
  localStorage.setItem(USER_PROFILE_KEY, JSON.stringify(profile));
}

export function getUserProfile() {
  try {
    const raw = localStorage.getItem(USER_PROFILE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function getTotalXp() {
  const profile = getUserProfile();
  const xp = profile?.totalXP ?? profile?.totalXp;
  return typeof xp === 'number' ? xp : Number(xp) || 0;
}

export function clearUserProfile() {
  localStorage.removeItem(USER_PROFILE_KEY);
}
